import {FilterOption} from "../types/filterTypes";
import axios from "@/utils/axios";
import {Competition} from "../types/eventTypes";

export async function getCompetitions(): Promise<Competition[]> {
    const response = await axios.get(`/competitions/getCompetitions`);
    return response.data;
}

// the single source of truth for "which competition" across every view (table, agenda,
// calendar, matchboard) and for matching against an event's own competition field -
// there's no reliable id to join on, so name + season is the shared key everywhere
export function getCompetitionKey(comp?: Pick<Competition, 'name' | 'season'> | null): string {
    if (!comp?.name) return '';
    return comp.season ? `${comp.name} - ${comp.season}` : comp.name;
}

export async function getCompetitionOptions(): Promise<FilterOption[]> {
    const response = await axios.get('/competitions/competitionsOptions')
    return response.data
}